import logo from './logo.svg'
import logoLogin from './logo-login.svg'

import loginBg from './login-bg.jpg'
import signUpBg from './sign-up-bg.png'
import headerBg from './header-bg.png'
import headerBgSm from './header-bg-sm.png'
import footerBg from './footer-bg.png'
import feedbacksBg from './feedbacks-bg.png'
import feedbacksBgSm from './feedbacks-bg-sm.png'
import notFound from './not-found.png'
import notFoundMd from './not-found-md.png'
import notFoundSm from './not-found-sm.png'
import checkMailbox from './check-mailbox.png'
import checkMailboxMd from './check-mailbox-md.png'
import checkMailboxSm from './check-mailbox-sm.png'
import restoreBg from './restore-bg.png'
import expiredBg from './expired-bg.png'
import expiredBgMd from './expired-bg-md.png'
import expiredBgSm from './expired-bg-sm.png'

import logout from './logout.svg'
import search from './search.svg'
import calendar from './calendar.svg'
import dots from './dots.svg'
import dotsWhite from './dots-white.svg'
import dotsBlack from './dots-black.svg'
import menu from './menu.svg'
import filter from './filter.svg'
import task from './task.svg'
import car from './car.svg'
import user from './user.svg'
import upload from './upload.svg'
import cross from './cross.svg'
import edit from './edit.svg'
import editSm from './edit-sm.svg'
import trash from './trash.svg'
import plus from './plus.svg'
import template from './template.svg'
import stat from './stat.svg'
import plans from './plans.svg'
import ok from './ok.svg'
import okSm from './ok-sm.svg'
import map from './map.svg'
import contacts from './contacts.svg'
import category from './category.svg'
import arrowUp from './arrow-up.svg'
import arrowDown from './arrow-down.svg'
import arrowLeft from './arrow-left.svg'
import arrowRight from './arrow-right.svg'
import arrowBack from './arrow-back.svg'
import stepArrow from './step-arrow.svg'
import reset from './reset.svg'
import mailOpen from './mail-open.svg'
import stopWatch from './stop-watch.svg'

import tabIcon1 from './tab-icon-1.svg'
import tabIcon1Sm from './tab-icon-1-sm.svg'
import tabIcon2 from './tab-icon-2.svg'
import tabIcon2Sm from './tab-icon-2-sm.svg'
import tabIcon3 from './tab-icon-3.svg'
import tabIcon3Sm from './tab-icon-3-sm.svg'
import wit from './wit.png'
import witSm from './wit-sm.png'
import witBottom from './wit-bottom.png'
import one from './one.svg'
import oneSm from './one-sm.svg'
import two from './two.svg'
import twoSm from './two-sm.svg'
import three from './three.svg'
import threeSm from './three-sm.svg'
import avaDirector from './ava-director.png'
import avaHOS from './ava-hos.png'
import avaSDR from './ava-sdr.png'
import avaCEO from './ava-ceo.png'
import attention from './attention.svg'
import quotesStart from './quotes-start.svg'
import quotesEnd from './quotes-end.svg'

//import defaultAvatar from './default_user.jpeg'
import burgerIcon from './burgerIcon.svg'
import settingsIcon from './_settings-icon.svg'
import plusIcon from './_plus.svg'
import verifiedIcon from './_verified-icon.svg'
import likeIcon from './_like-icon.svg'
import sharesIcon from './_shares-icon.svg'
import sharesIconDark from './_shares-icon_dark.svg'
import viewIcon from './_view-icon.svg'
import viewIconDark from './_view-icon_dark.svg'
import commentIcon from './_comment-icon.svg'
import commentIconDark from './_comment-icon_dark.svg'
import notSavedPostIcon from './_not-saved-post-icon.svg'
import notSavedPostIconDark from './_not-saved-post-icon_dark.svg'
import savedPostIcon from './_saved-post-icon.svg'
import globalLinkIcon from './_global-link-icon.svg'
import detailsLinkIcon from './_details-link-icon.svg'
import arrowLinkIcon from './_arrow-link-icon.svg'
import addIcon from './_add.svg'
import plusCircleIcon from './_plus-circle.svg'
import plusCircleBlueIcon from './_plus-circle_blue.svg'
import checkCircleIcon from './_check_circle.svg'
import checkIcon from './_check.svg'
import downloadIcon from './_download-icon.svg'
import arrowCircleIcon from './_arrow-circle.svg'
import chart from './_chart.png'
import arrowChart from './_arrow_chart.svg'
import closeIcon from './_close.svg'
import calculatorCPA from './_calculator_cpa.svg'
import calculatorCPADark from './_calculator_cpa_dark.svg'
import calculatorCPAActive from './_calculator_cpa_active.svg'
import calculatorROAS from './_calculator_roas.svg'
import calculatorROASDark from './_calculator_roas_dark.svg'
import calculatorROASActive from './_calculator_roas_active.svg'
import calculatorBEROAS from './_calculator_beroas.svg'
import calculatorBEROASDark from './_calculator_beroas_dark.svg'
import calculatorBEROASActive from './_calculator_beroas_active.svg'

import genderLogo from './_gender-logo.svg'
import emptyChartPerformanceBg from './_empty-chart-performance-bg.svg'
import emptyChartStatusBg from './_empty-chart-status-bg.svg'
import emptyChartTargetingBg from './_empty-chart-targeting-bg.png'
import emptyInterestBg from './_empty_interest.svg'

import tableSortDescendActive from './_table-sort-descend-active-icon.svg'
import tableSortDescend from './_table-sort-descend-icon.svg'
import tableSortAscendActive from './_table-sort-ascend-active-icon.svg'
import tableSortAscend from './_table-sort-ascend-icon.svg'

import listIcon from './_list_icon.svg'
import dotsIcon from './_dots_icon.svg'
import dotsIconDark from './_dots_icon_dark.svg'
import dotsSmallIcon from './_dots_small_icon.svg'
import dotsSmallIconDark from './_dots_small_icon_dark.svg'
import dotsMediumIcon from './_dots_medium_icon.svg'
import dotsMediumIconDark from './_dots_medium_icon_dark.svg'
import calendarIcon from './_calendar_icon.svg'
import cloudUpload from './cloud-upload.svg'
import lightBulbImpove from './light-bulb-1.svg'
import lightBulbHelp from './light-bulb-2.svg'
import verifiedSucsess from './verified-1.svg'
import urlLink from './_url_link.svg'
import checkCircleOutline from './_check_circle_outline.svg'
import mastercard from './_Mastercard.svg'
import maestro from './_Maestro.svg'
import americanExpress from './_AmericanExpress.svg'
import visa from './_VISA.svg'
import payPal from './_PayPal.svg'

import logoCard_visa from './_logo_card_visa.svg'
import logoCard_mastercard from './_logo_card_mastercard.svg'
import logoCard_maestro from './_logo_card_maestro.svg'
import logoCard_amex from './_logo_card_american-express.svg'

import paymentFailedCard from './_payment-failed-card.svg'
import paymentSuccessfulCard from './_payment-successful-card.svg'
import payment3DSecure from './_payment-3d-secure.svg'
import upgradePlan from './_upgrade_icon.svg'
import downgradePlan from './_downgrade_icon.svg'
import cardInvoice from './_card-invoice.svg'
import logoInvoice from './_logo-invoice.svg'
import logoInvoiceError from './_logo-invoice-error.svg'
import defaultAvatar from './_default-avatar.svg'
import defaultAvatarDark from './_default-avatar-dark.svg'
import loginSlideAdlibrary from './_login-slide-adlibrary.png'
import loginSlideWatchlist from './_login-slide-watchlist.png'
import loginSlideTop from './_login-slide-top.png'
import loginSlideInterest from './_login-slide-interest.png'
import defaultImg from './_default-img.svg'
import bitPay from './_BitPay.svg'
import bitcoinBtc from './_bitcoin-btc.svg'
import bitcoinCash from './_bitcoin-cash.svg'
import litecoinCash from './_litecoin-cash.svg'
import ethereum from './_ethereum.svg'
import xrp from './_xrp.svg'
import chainlink from './_chainlink.svg'
import cardano from './_cardano.svg'
import welcomeBg from './_welcome-bg.png'
import paymentCard from './_payment-card.svg'

import plusWhite from './plus_white.svg'
import attentionMedium from './_attention-medium.svg'
import plusBlue from './plus_blue.svg'

const Images = {
  logo: logo,
  logoLogin: logoLogin,
  // backgraunds
  loginBg: loginBg,
  signUpBg: signUpBg,
  headerBg: headerBg,
  headerBgSm: headerBgSm,
  footerBg: footerBg,
  feedbacksBg: feedbacksBg,
  feedbacksBgSm: feedbacksBgSm,
  notFound: notFound,
  notFoundMd: notFoundMd,
  notFoundSm: notFoundSm,
  checkMailbox: checkMailbox,
  checkMailboxMd: checkMailboxMd,
  checkMailboxSm: checkMailboxSm,
  restoreBg: restoreBg,
  expiredBg: expiredBg,
  expiredBgMd: expiredBgMd,
  expiredBgSm: expiredBgSm,
  // icons
  logout: logout,
  search: search,
  calendar: calendar,
  dots: dots,
  dotsWhite: dotsWhite,
  dotsBlack: dotsBlack,
  menu: menu,
  filter: filter,
  task: task,
  car: car,
  user: user,
  upload: upload,
  cross: cross,
  edit: edit,
  editSm: editSm,
  trash: trash,
  plus: plus,
  template: template,
  stat: stat,
  plans: plans,
  ok: ok,
  okSm: okSm,
  map: map,
  contacts: contacts,
  category: category,
  arrowUp: arrowUp,
  arrowDown: arrowDown,
  arrowLeft: arrowLeft,
  arrowRight: arrowRight,
  arrowBack: arrowBack,
  stepArrow: stepArrow,
  reset: reset,
  mailOpen: mailOpen,
  stopWatch: stopWatch,

  // landing icons
  tabIcon1: tabIcon1,
  tabIcon1Sm: tabIcon1Sm,
  tabIcon2: tabIcon2,
  tabIcon2Sm: tabIcon2Sm,
  tabIcon3: tabIcon3,
  tabIcon3Sm: tabIcon3Sm,
  wit: wit,
  witSm: witSm,
  witBottom: witBottom,
  one: one,
  oneSm: oneSm,
  two: two,
  twoSm: twoSm,
  three: three,
  threeSm: threeSm,
  avaDirector: avaDirector,
  avaHOS: avaHOS,
  avaSDR: avaSDR,
  avaCEO: avaCEO,
  attention: attention,
  quotesStart: quotesStart,
  quotesEnd: quotesEnd,

  settingsIcon,
  burgerIcon,
  defaultAvatar,
  plusIcon,
  verifiedIcon,
  likeIcon,
  commentIcon,
  commentIconDark,
  notSavedPostIcon,
  notSavedPostIconDark,
  savedPostIcon,
  globalLinkIcon,
  detailsLinkIcon,
  arrowLinkIcon,
  sharesIcon,
  sharesIconDark,
  genderLogo,
  emptyChartPerformanceBg,
  emptyChartStatusBg,
  emptyChartTargetingBg,
  emptyInterestBg,
  viewIcon,
  viewIconDark,
  addIcon,
  plusCircleIcon,
  plusCircleBlueIcon,
  checkCircleIcon,
  checkIcon,
  downloadIcon,
  arrowCircleIcon,
  chart,
  arrowChart,
  closeIcon,
  calculatorCPA,
  calculatorCPADark,
  calculatorCPAActive,
  calculatorROAS,
  calculatorROASDark,
  calculatorROASActive,
  calculatorBEROAS,
  calculatorBEROASDark,
  calculatorBEROASActive,

  tableSortDescendActive: tableSortDescendActive,
  tableSortDescend: tableSortDescend,
  tableSortAscendActive: tableSortAscendActive,
  tableSortAscend: tableSortAscend,

  listIcon,
  dotsIcon,
  dotsIconDark,
  dotsMediumIcon,
  dotsMediumIconDark,
  dotsSmallIcon,
  dotsSmallIconDark,
  calendarIcon,
  cloudUpload,
  lightBulbHelp,
  lightBulbImpove,
  verifiedSucsess,
  urlLink,
  checkCircleOutline,

  mastercard,
  maestro,
  americanExpress,
  visa,
  payPal,
  paymentFailedCard,
  paymentSuccessfulCard,
  payment3DSecure,
  upgradePlan,
  downgradePlan,
  logoCard_visa,
  logoCard_mastercard,
  logoCard_maestro,
  logoCard_amex,
  cardInvoice,
  logoInvoice,
  logoInvoiceError,
  defaultAvatarDark,
  loginSlideAdlibrary,
  loginSlideWatchlist,
  loginSlideTop,
  loginSlideInterest,
  defaultImg,
  bitPay,
  bitcoinBtc,
  bitcoinCash,
  litecoinCash,
  ethereum,
  xrp,
  chainlink,
  cardano,
  welcomeBg,
  paymentCard,
  plusWhite,
  attentionMedium,
  plusBlue,
}

export default Images
